import {registerPlugin, CapacitorHttp} from '@capacitor/core';

import { Geolocation } from '@capacitor/geolocation';
import { NativeSettings, AndroidSettings, IOSSettings } from 'capacitor-native-settings';
import store from '../store';

const BackgroundGeolocation = registerPlugin('BackgroundGeolocation');

export class Geobackground {
    constructor () {
        this.watcher_id = null;
        this.isStarted = false;
        this.callbackId = null;
        this.bgOptions = {
            stationaryRadius: 1,
            distanceFilter: 1,
            desiredAccuracy: 10,
            notificationTitle: process.env.APP_NAME || 'MyRide',
            notificationText: 'Buscando viajes cercanos',
            notificationIconColor: '#5C1889',
            stopOnTerminate: true,
            startOnBoot: false
        };
        this.url = '';
        this.headers = {};

        this.bgOptions = {
            // If the "backgroundMessage" option is defined, the watcher will
            // provide location updates whether the app is in the background or the
            // foreground. If it is not defined, location updates are only
            // guaranteed in the foreground. This is true on both platforms.

            // On Android, a notification must be shown to continue receiving
            // location updates in the background. This option specifies the text of
            // that notification.
            backgroundMessage: 'Buscando viajes cercanos',

            // The title of the notification mentioned above. Defaults to "Using
            // your location".
            backgroundTitle: process.env.APP_NAME || 'MyRide',

            // Whether permissions should be requested from the user automatically,
            // if they are not already granted. Defaults to "true".
            requestPermissions: true,

            // If "true", stale locations may be delivered while the device
            // obtains a GPS fix. You are responsible for checking the "time"
            // property. If "false", locations are guaranteed to be up to date.
            // Defaults to "false".
            stale: false,

            // The minimum number of metres between subsequent locations. Defaults
            // to 0.
            distanceFilter: 0
        };
    }

    /**
    * Check if location services are enabled
    */

    async checkLocationMode () {
        try {
            const enabled = await Geolocation.checkPermissions();
            return enabled;
        } catch (error) {
            console.error('Error checking location mode:', error);
            throw error;
        }
    }

    showLocationSettings () {
        NativeSettings.open({
            optionAndroid: AndroidSettings.Location,
            optionIOS: IOSSettings.App
        });
    }

    async watchLocationMode (flag) {
        if (flag) {
            try {
                const options = {
                    enableHighAccuracy: true, // Alta precisión
                    timeout: 10000,
                    maximumAge: 0
                };
                store.dispatch('geolocation/toogleSettings', true);
                this.callbackId = await Geolocation.watchPosition(options, (position, err) => {
                    if (err) {
                        return;
                    }
                    this.newPosition(position);
                });
            } catch (error) {
                console.error('Geolocation error:', error);
            }
        } else {
            store.dispatch('geolocation/toogleSettings', false);
            await Geolocation.clearWatch(this.callbackId);
            this.callbackId = null;
        }
    }

    /**
     * Start brackgound tracking
     */

    async startTracking () {
        if (this.isStarted) {
            return;
        }
        this.userStartIntent = true;
        this.isStarted = true;
        this.watcher_id = await BackgroundGeolocation.addWatcher(this.bgOptions, (location, error) => {
            this.doPost(location);
        });

        // return new Promise((resolve, reject) => {
        //     this.bg.start(
        //         resolve,
        //         (error) => {
        //             console.log('bg location error:', error);
        //             this.stopTracking();
        //             reject(error.code);
        //         }
        //     );
        //     this.isStarted = true;
        //     // [TODO] Ver si esto va dentro del callback del start. Por si falla.
        //     setTimeout(function () {
        //         if (this.bg && this.bg.changePace) {
        //             this.bg.changePace(true, () => {
        //                 console.log('ChangePace OK');
        //             }, () => {
        //                 console.log('ChangePace not working');
        //             });
        //         }
        //     }.bind(this), 15 * 1000);
        // });
    }

    /**
     * Stop trackin in background
     */

    stopTracking () {
        if (!this.isStarted) {
            return;
        }

        BackgroundGeolocation.removeWatcher({ id: this.watcher_id });
        this.isStarted = false;
        this.userStartIntent = false;
        this.watcher_id = null;
    }

   /**
    * Handler for new position
    */

    newPosition (position) {
        console.log('NUEVA POSICION', position);
        store.commit('geolocation/LOCATION_ENABLED_SET', true);
        let pos = {
            lat: position.latitude,
            lng: position.longitude
        };
        store.commit('geolocation/SET_POSITION', pos);

        if (this.bg && this.bg.finish) {
            this.bg.finish();
        }
    }

   /**
    * Error Handler for new position
    */

    errorPosition (error) {
        console.log('Error occured', error);
    };

    configure (url, headers) {
        this.url = url;
        this.headers = headers;
        // this.showLocationSettings();
        // let callBack = this.newPosition.bind(this);
        // let erroBack = this.errorPosition.bind(this);

        // let options = Object.assign({}, this.bgOptions);

        // if (url) {
        //     options.url = url;
        //     options.httpHeaders = headers;
        // }

        // options.locationProvider = this.bg.provider.ANDROID_ACTIVITY_PROVIDER;

        // if (this.isStarted) {
        //     this.stopTracking();
        //     this.bg.configure(
        //        callBack,
        //        erroBack,
        //        options
        //     );
        //     this.startTracking();
        // } else {
        //     this.bg.configure(
        //        callBack,
        //        erroBack,
        //        options
        //    );
        // }
    }

    async doPost (location) {
        const options = {
            url: this.url,
            headers: this.headers,
            data: [location]
        };
        await CapacitorHttp.post(options);

        // or...
        // const response = await CapacitorHttp.request({ ...options, method: 'POST' })
    };
}



// WEBPACK FOOTER //
// ./src/cordova/Geobackground.js